import { createFeatureSelector, createSelector } from '@ngrx/store';
import { LoadingState } from './loading.interface';
import { LOADING_FEATURE_KEY } from './loading.reducer';

export const selectLoadingState = createFeatureSelector<LoadingState>(LOADING_FEATURE_KEY);

export const selectLoading = (key: string) => createSelector(
    selectLoadingState,
    (state: LoadingState) => state[key] || false
);

export const selectAnyLoading = createSelector(
    selectLoadingState,
    (state: LoadingState) => Object.values(state).some(loading => loading)
);